import './TimesheetList.css'
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
momentDurationFormatSetup(moment);
import { useEffect, useState } from 'react';
import { Timesheet } from '../data/Timesheet';
import { useRootStore } from '../hooks/useRootStore';
import { Box, Checkbox, CircularProgress, FormControlLabel, Tooltip } from '@mui/material';
import MarkdownView from './MarkdownView';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from './ConfirmDialog';

export default function TimesheetList({ issueId }: { issueId: number }) {
    const { api } = useRootStore();
    const [activities, setActivities] = useState([] as Timesheet[]);
    const [loading, setLoading] = useState(true);
    const [renderMarkdownChecked, setRenderMarkdownChecked] = useState(true);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRenderMarkdownChecked(event.target.checked);
    };

    const [confirmDeletingId, setConfirmDeletingId] = useState(0);

    const tryDeleteTimesheet = (id: number) => {
        setConfirmDeletingId(id);        
    }

    const deleteTimesheet = (id: number) => {
        api.deleteTimesheetDocument(confirmDeletingId).then(() => {            
            setActivities(activities.filter(x => x.ID != id));
            setConfirmDeletingId(0);
        });
    }

    const columns: GridColDef[] = [
        { field: 'StartDate', headerName: 'Начало', align: 'center', width: 150, valueFormatter: (value?: Date) => value ? moment(value).format("DD.MM.YY HH:mm") : null },
        { field: 'StopDate', headerName: 'Окончание', align: 'center', width: 150, valueFormatter: (value?: Date) => value ? moment(value).format("DD.MM.YY HH:mm") : null },
        { field: 'WorkerID', headerName: 'Исполнитель', width: 180, renderCell: (params) => <Link href={`/employees/${params.value}`}>{params.row.WorkerName}</Link> },
        { field: 'Hours', headerName: 'Часы', width: 80, align: 'center', headerAlign: 'center', renderCell: (params) => <span style={{ color: params.row.IsOffDuty ? 'red' : '' }}>{moment.duration(params.value * 60 * 60 * 1000).format("hh:mm", { trim: false })}</span> },
        { field: 'Comment', flex: 1, headerName: 'Комментарий', renderCell: (params) => !renderMarkdownChecked ? params.value : <MarkdownView markup={params.value ? params.value : ''} /> },
        { field: 'Delete', width: 50, align: 'center', headerName: '', renderCell: (params) => <Tooltip title='Удалить записанное время' onClick={() => tryDeleteTimesheet(params.row.ID)}><DeleteIcon color={'info'} /></Tooltip>},
    ];

    useEffect(() => {
        api.getIssueTimesheets(issueId).then(timesheets => {
            setActivities(timesheets);
            setLoading(false);
        });
    }, [api, issueId])

    //const paginationModel = { page: 0, pageSize: 15 };
    
    return (
        loading
            ?
            <Box sx={{ textAlign:'center', p:5 }}>
                <CircularProgress />
            </Box>
            :
            <Paper sx={{ display: 'flex', pl: 2, flexDirection: 'column', position: 'absolute', top: 0, left: 0, right: 20, bottom: 0 }}>
                {confirmDeletingId ? <ConfirmDialog text='Удалить записанное время?' confirmBtnText='Да' onCancel={() => setConfirmDeletingId(0)} onConfirm={() => deleteTimesheet(confirmDeletingId)} /> : ''}
                <Box sx={{ mb: 1, ml: 2 }}>
                    <FormControlLabel control={<Checkbox defaultChecked={true} onChange={handleChange} />} label="Рендерить маркдаун" />
                </Box>

                <DataGrid
                    rows={activities}
                    getRowHeight={() => 'auto'}
                    getRowId={(row) => row.ID}
                    columns={columns}
                    className="timesheets-grid"
                    disableColumnMenu
                    hideFooterPagination={activities.length <= 100}
                    //initialState={{ pagination: { paginationModel } }}
                    //pageSizeOptions={[5, 10]}
                    // checkboxSelection
                    sx={{ border: 0 }}
                />
            </Paper>
    )
}